module.exports = __webpack_public_path__ + "media/images/bing-08fceff19202dd94c2e9301436c4592d.jpg";